
















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

import IQuestion from '@/models/IQuestion'
import IAnswer from '@/models/IAnswer'
import { EventBus } from '@/event-bus'

interface IQuestionMap extends IQuestion {
  active: boolean
}

@Component({
  name: 'c-question-box-branch-dialog'
})
export default class QuestionBoxBranchDialog extends Vue {
  @Prop({
    type: Array,
    default: () => []
  }) questions!: IQuestion[]

  @Prop({type: String}) title: string | undefined

  @Prop({
    type: String,
    required: true
  }) id!: string

  @Prop({
    type: String,
    required: true
  }) answerId!: string

  @Prop({
    type: Array,
    default: () => []
  }) includeQuestions: string[] | undefined

  search: string = ''
  value: string = ''
  questionsValueMap: IQuestionMap[] = []

  @Emit()
  close (): void {
    this.resetForm()
  }

  get questionsBySearch (): IQuestion[] {
    return this.questionsValueMap.filter((v: IQuestion) => {
      if (!this.search) {
       if(v.type != 'text_comment')
         if(v.type != 'text_post')
         return true

      } else {
        const re = new RegExp(this.search, 'i')
        return re.test(v.text)
      }
    })
  }

  submit (): void {
    const questionId: string = this.id // ID родительского вопроса
    const answerId: string = this.answerId // ID ответа

    // ID выбранных вопросов
    const includeQuestions: string[] = this.questionsValueMap
      .filter(v => v.active)
      .map(v => v.id)

    this.close()
    EventBus.$emit('questionBranchSubmited', {
      questionId,
      answerId,
      includeQuestions
    })
  }

  created (): void {
    this.questionsValueMap = this.questions
      .filter((v: IQuestion) => v.id !== this.id)
      .map((v: IQuestion) => ({
        ...v,
        active: this.includeQuestions ? this.includeQuestions.includes(v.id) : false
      }))
  }

  resetForm (): void {
    this.search = ''
  }
}
